import { trace } from 'rytm-helpers'
import { TweenMax, TimelineMax, Power0, Power1, Power2, Power3, Power4, Back, Bounce, Elastic, Expo, Sine } from 'gsap'

const BRAND_ANIM_OFFSET_Y = 40;
const BRAND_ANIM_SCALE = .1;

export const initBrandAnimation = () => {
  document.addEventListener("mouseover", onDocMouseOver)
  document.addEventListener("mouseout", onDocMouseOut)
}

const onDocMouseOver = (e) => {
  if (e.target.matches('a.brand-logo-anim')) {
    logoAnimationIn(e.target.querySelector('svg'));
  }
}
const onDocMouseOut = (e) => {
  if (e.target.matches('a.brand-logo-anim')) {
    logoAnimationOut(e.target.querySelector('svg'));
  }
}

const logoAnimationIn = (svg) => {
  const listHero = [...svg.querySelectorAll('.hero g')]
  const listTitle = [...svg.querySelectorAll('.title g')]
  TweenMax.killTweensOf(listHero)
  TweenMax.killTweensOf(listTitle)
  TweenMax.set(listTitle, {opacity: 0, y: BRAND_ANIM_OFFSET_Y, scale: BRAND_ANIM_SCALE})
  TweenMax.to(listHero, {
    opacity: 0,
    y: -BRAND_ANIM_OFFSET_Y,
    scale: BRAND_ANIM_SCALE,
    duration: .4, 
    stagger: .08, 
    ease: Back.easeInOut,
    delay: 0,
  })
  TweenMax.to(listTitle, {
    opacity: 1, 
    y: 0,
    scale: 1,
    duration: .4, 
    stagger: .03, 
    ease: Back.easeInOut,
    delay: .05,
  })

}
const logoAnimationOut = (svg) => {
  const listHero = [...svg.querySelectorAll('.hero g')]
  const listTitle = [...svg.querySelectorAll('.title g')]
  TweenMax.killTweensOf(listHero)
  TweenMax.killTweensOf(listTitle)
  TweenMax.set(listHero, {opacity: 0, y: BRAND_ANIM_OFFSET_Y, scale: BRAND_ANIM_SCALE})
  // TweenMax.set(listTitle, {opacity: 1, y: 0})
  TweenMax.to(listHero, {
    opacity: 1, 
    y: 0,
    scale: 1,
    duration: .4, 
    stagger: .08, 
    ease: Back.easeInOut,
    delay: .15,
  })
  TweenMax.to(listTitle, {
    opacity: 0, 
    y: -BRAND_ANIM_OFFSET_Y,
    scale: BRAND_ANIM_SCALE,
    duration: .4, 
    stagger: .03, 
    ease: Back.easeInOut,
    delay: 0,
  })
}